import { render, staticRenderFns } from "./BatchUpdateNoteDialog.vue?vue&type=template&id=162466ba&scoped=true"
import script from "./BatchUpdateNoteDialog.vue?vue&type=script&lang=js"
export * from "./BatchUpdateNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchUpdateNoteDialog.vue?vue&type=style&index=0&id=162466ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162466ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162466ba')) {
      api.createRecord('162466ba', component.options)
    } else {
      api.reload('162466ba', component.options)
    }
    module.hot.accept("./BatchUpdateNoteDialog.vue?vue&type=template&id=162466ba&scoped=true", function () {
      api.rerender('162466ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/BatchUpdateNoteDialog.vue"
export default component.exports